import { useState } from "react";
import type { DiscordSession } from "../discord";
import { SKUS } from "../discord";

interface Props {
  session: DiscordSession;
  onClose: () => void;
  onPurchased: () => void;
}

export function Shop({ session, onClose, onPurchased }: Props) {
  const [busy, setBusy] = useState(false);
  const owned = session.cosmetics.catnipPack;

  const buyCatnip = async () => {
    setBusy(true);
    try {
      const ok = await session.purchase(SKUS.catnipPack);
      if (ok) onPurchased();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <header className="modal-head">
          <h2>Catnip Pack</h2>
          <button className="ghost" onClick={onClose}>
            close
          </button>
        </header>

        <p className="muted">
          One purchase, forever yours. Cosmetics only — no pay-to-win, no extra
          rounds, just style.
        </p>

        <ul className="perks">
          <li>10 extra brush colors (lavender, coral, teal, the works)</li>
          <li>Gold ring on your avatar so the lobby knows what's up</li>
          <li>Future packs: animated cursors, victory dances, custom backgrounds</li>
        </ul>

        {owned ? (
          <div className="owned">You already own the Catnip Pack. Purrfect.</div>
        ) : (
          <button
            className="primary big"
            onClick={buyCatnip}
            disabled={busy || !SKUS.catnipPack || session.mock}
          >
            {session.mock
              ? "Available in Discord only"
              : busy
              ? "Opening Discord..."
              : "Unlock Catnip Pack"}
          </button>
        )}

        <p className="muted small">
          Purchases are handled by Discord. Your payment never touches our servers.
        </p>
      </div>
    </div>
  );
}
